// extracted by mini-css-extract-plugin
export default {"ImgPlusButtons":"ImgAndButtons_ImgPlusButtons__wMgKf","Img":"ImgAndButtons_Img__d1HXk","ButtonsContainer":"ImgAndButtons_ButtonsContainer__dL8Oc"};